export function withResolvers() {
  let resolve = null;
  let reject = null;
  const promise = new Promise((resolveFn, rejectFn) => {
    resolve = resolveFn;
    reject = rejectFn;
  });
  return {
    promise,
    resolve,
    reject
  };
}
//# sourceMappingURL=utils.js.map